import { render, staticRenderFns } from "./top-performers.vue?vue&type=template&id=146e2074&scoped=true"
import script from "./top-performers.vue?vue&type=script&lang=js"
export * from "./top-performers.vue?vue&type=script&lang=js"
import style0 from "./top-performers.vue?vue&type=style&index=0&id=146e2074&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e2074",
  null
  
)

export default component.exports